import React from "react";

export function Option(props: React.PropsWithChildren) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      {props.children}
    </div>
  );
}

Option.Header = function (props: React.PropsWithChildren) {
  return <div {...props} />;
};
Option.Title = function (props: React.PropsWithChildren) {
  return (
    <div
      style={{
        fontSize: "var(--gm-text-sm)",
        fontWeight: 500,
        color: "var(--gm-color-dark-primary)",
      }}
    >
      {props.children}
    </div>
  );
};

Option.SubTitle = function (props: React.PropsWithChildren) {
  return (
    <div>
      <div
        style={{
          color: "var(--gm-color-dark-primary)",
          fontSize: "0.9rem",
        }}
      >
        {props.children}
      </div>
    </div>
  );
};
